import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatButton } from '@blocks-react/components/Button';

type CatButtonProps = ComponentProps<typeof CatButton> & { classname?: string };

export const CustomerAccountRetryButton: FC<
  PropsWithChildren<CatButtonProps>
> = ({ children, classname, ...buttonProps }) => (
  <CatButton variant="ghost" {...buttonProps}>
    <div className={`d-flex ${classname}`}>{children}</div>
  </CatButton>
);
